"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgBox = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  "data-name": "Regular 1.5px/box",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Regular 1.5px/box background",
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }, void 0), (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Combined Shape",
    d: "M19 22H5a3 3 0 01-3-3V7a.5.5 0 01.007-.083 2.668 2.668 0 01.777-1.7l2.337-2.339A2.98 2.98 0 017.242 2h9.515a2.98 2.98 0 012.121.878l2.338 2.338a2.677 2.677 0 01.777 1.7A.494.494 0 0122 7v12a3 3 0 01-3 3zM3.5 8v11A1.5 1.5 0 005 20.5h14a1.5 1.5 0 001.5-1.5V8H16v3a3 3 0 01-3 3h-2a3 3 0 01-3-3V8zm6 0v3a1.5 1.5 0 001.5 1.5h2a1.5 1.5 0 001.5-1.5V8zm4.867-4.5l1.4 3h4.563a1.188 1.188 0 00-.175-.223l-2.337-2.338a1.491 1.491 0 00-1.061-.439zm-3.078 0l-1.4 3h4.223l-1.4-3zm-4.046 0a1.486 1.486 0 00-1.06.439L3.844 6.277a1.185 1.185 0 00-.175.223h4.564l1.4-3z",
    fill: "#2d5dec"
  }, void 0)]
}), void 0);

exports.default = SvgBox;